/* import __COLOCATED_TEMPLATE__ from './cx-benchmark-panel.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { type CxBenchmarkIndustry } from 'embercom/components/reporting/bespoke/fin-performance/cx-benchmark-panel/types';
import {
  getCxBenchmarkData,
  getBenchmarkGroup,
  getIndustryDisplayName,
  getAvailableIndustries,
} from 'embercom/lib/reporting/cx-benchmarks/cx-benchmark-service';

interface Signature {
  Args: {
    isOpen: boolean;
    onClose: () => void;
    appCxScore: number | undefined;
  };
}

export default class CxBenchmarkPanel extends Component<Signature> {
  @service declare intl: IntlService;
  @tracked selectedIndustry: CxBenchmarkIndustry = 'overall';

  get benchmarkData() {
    return getCxBenchmarkData();
  }

  // app_segment will be resolved per-workspace by the API. Default to 'overall' for now.
  get appSegment(): string {
    return this.benchmarkData.app_segment ?? 'overall';
  }

  get selectedBenchmarkGroup() {
    return getBenchmarkGroup(this.benchmarkData, this.selectedIndustry, this.appSegment);
  }

  get selectedIndustryLabel() {
    return getIndustryDisplayName(this.intl, this.selectedIndustry);
  }

  get industryItems() {
    return getAvailableIndustries(this.benchmarkData).map((industry) => ({
      text: getIndustryDisplayName(this.intl, industry),
      value: industry,
    }));
  }

  @action
  onSelectIndustry(industry: CxBenchmarkIndustry) {
    this.selectedIndustry = industry;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Bespoke::FinPerformance::CxBenchmarkPanel': typeof CxBenchmarkPanel;
    'reporting/bespoke/fin-performance/cx-benchmark-panel': typeof CxBenchmarkPanel;
  }
}
